import { gql } from "@apollo/client";

export const UPDATE_HORSE = gql`
  mutation HorseMutation($input: UpdateHorseInput!) {
    updateHorse(input: $input) {
      color
      createdAt
      dob
      height
      id
      name
      photo
      scannedAt
      status
      updatedAt
      weight
      discipline
      isDeleted
      registeredName
    }
  }
`;